import { useMemo } from 'react';

import useDispatchAction from 'hooks/useDispatchAction';
import { getProviderPayingAccountsAction, getBankAccountsAction } from 'domain/paySettings';

const useGetAccounts = (providerId: string) => {
  const payload = useMemo(() => ({ id: providerId }), [providerId]);

  const {
    data: payingAccounts = [],
    isLoading: isLoadingPayingAccounts,
    setData,
  } = useDispatchAction(getProviderPayingAccountsAction, payload, []);

  const { data: bankAccounts = [], isLoading: isLoadingBankAccounts } = useDispatchAction(
    getBankAccountsAction,
    payload,
    [],
  );

  const updatedPayingAccounts = useMemo(() => {
    if (isLoadingPayingAccounts || isLoadingBankAccounts) return [];

    const bankMap = new Map((bankAccounts as any[]).map((b: any) => [b.value, b.label]));

    return (payingAccounts as any[]).map((acc: any) => ({
      ...acc,
      erpBankAccountName: bankMap.get(acc?.glBankAccountId) || null,
    }));
  }, [payingAccounts, bankAccounts, isLoadingPayingAccounts, isLoadingBankAccounts]);

  return {
    isLoading: isLoadingPayingAccounts || isLoadingBankAccounts,
    data: updatedPayingAccounts,
    setData,
    bankAccounts,
  };
};

export default useGetAccounts;
